function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { PATTERNS_VALIDATION, ALL_TABLES_OPTION } from '@/js/constants';
import MoreFilterSearch from '@/components/MoreFilterSearch.vue';
import tasks from '@/js/tasks';
export default {
  name: 'MainSearch',
  components: {
    MoreFilterSearch: MoreFilterSearch
  },
  data: function data() {
    return {
      q: '',
      SEARCH_PATTERN: PATTERNS_VALIDATION.MAIN_SEARCH,
      buttons: [],
      list_domains: ['aaa', 'bbbb'],
      pick_domain: 'Domains'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isTableauActive', 'mainQueryBy', 'isPowerBIActive', 'isDataStudioActive'])), {}, {
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
      list_domains.unshift(window.userInfo.domain);
      list_domains.push(ALL_TABLES_OPTION);
      return list_domains;
    },
    domainUser: function domainUser() {
      return window.userInfo.domain;
    },
    getSearchMini: function getSearchMini() {
      return this.$parent.isSearchMini;
    }
  }),
  created: function created() {
    this.q = this.$router.currentRoute.params.q;
    this.pick_domain = this.$router.currentRoute.params.domain ? this.$router.currentRoute.params.domain : window.userInfo.domain;
  },
  mounted: function mounted() {
    //this.changeButtonState()
    this.$store.dispatch('data-platform/getBusinessDomainQuery');
    this.$store.commit('data-platform/setIsDomainItc', window.userInfo.domain === 'intercorp.com.pe');
  },
  methods: {
    closeBackground: function closeBackground() {
      this.$parent.isSearchMini = false;
      this.$parent.isUserMenu = false;
    },
    openSearchMini: function openSearchMini() {
      this.$parent.isSearchMini = !this.$parent.isSearchMini;
      this.$parent.isUserMenu = false;
    },
    showMiniMenu: function showMiniMenu() {
      this.$parent.menuSmallShow = !this.$parent.menuSmallShow;
      this.$parent.isSearchMini = false;
      this.$parent.isUserMenu = false;
    },
    sendToSearch: function sendToSearch() {
      if (!this.q) {
        return false;
      }
      if (this.q.trim().length == 0 || this.q.trim().length < 2) {
        tasks.toast.error("Enter at least 2 characters!");
        //this.$toast.warning("Enter at least 2 characters!")
        return false;
      }
      // change url
      var c = {};
      this.q = this.preparedSearch(this.q);
      if (this.$route.params.q === this.q) {
        c = this.$route.query && this.$route.query['_'] === undefined ? {
          _: '',
          all: this.buttons[7].state,
          table: this.buttons[0].state,
          term: this.buttons[1].state,
          data: this.buttons[2].state,
          book: this.buttons[3].state,
          dataset: this.buttons[4].state,
          report: this.buttons[5].state,
          report_gds: this.buttons[6].state
        } : {
          all: this.buttons[7].state,
          table: this.buttons[0].state,
          term: this.buttons[1].state,
          data: this.buttons[2].state,
          book: this.buttons[3].state,
          dataset: this.buttons[4].state,
          report: this.buttons[5].state,
          report_gds: this.buttons[6].state
        };
      } else {
        c = {
          all: this.buttons[7].state,
          table: this.buttons[0].state,
          term: this.buttons[1].state,
          data: this.buttons[2].state,
          book: this.buttons[3].state,
          dataset: this.buttons[4].state,
          report: this.buttons[5].state,
          report_gds: this.buttons[6].state
        };
      }
      this.$bus.$emit('click-pill-search', this.buttons.filter(function (x) {
        return x.state == true;
      })[0]);
      this.$router.push({
        name: 'ContObjectSearch',
        params: {
          q: this.q,
          domain: this.pick_domain
        },
        query: c
      });
      return true;
    },
    preparedSearch: function preparedSearch(search) {
      var busqueda = search.toLowerCase();
      var aux = [];
      for (var x = 0; x < busqueda.length; x++) {
        aux.push(busqueda.charAt(x));
      }
      if (aux[0] === ' ') {
        aux.splice(0, 1);
      }
      if (aux[aux.length - 1] === ' ') {
        aux.pop();
      }
      busqueda = aux.join('');
      return busqueda;
    },
    onClickButton: function onClickButton(button) {
      this.buttons.forEach(function (item) {
        item.state = item.name === button.name ? true : false;
      });
      var isSearch = this.sendToSearch();
      if (!isSearch) return;
      this.$bus.$emit('click-pill-search', button);
      if (!isSearch) return;
      this.$store.dispatch('data-platform/setMainQueryBy', button.name);
    },
    changeButtonState: function changeButtonState() {
      var _this = this;
      this.$store.dispatch('data-platform/getIsTableauActive').then(function () {
        _this.buttons = [{
          caption: 'Table/View',
          state: _this.$route.query.table === 'true' || false,
          color: 'success',
          name: 'table',
          disabled: false
        }, {
          caption: 'Business Term',
          state: _this.$route.query.business === 'true' || false,
          color: 'indigo',
          name: 'business',
          disabled: false
        }, {
          caption: 'TBL DataSource',
          state: _this.$route.query.datasource === 'true' || false,
          color: 'orange',
          name: 'datasource',
          disabled: !_this.isTableauActive
        }, {
          caption: 'TBL Dashboard',
          state: _this.$route.query.dashboard === 'true' || false,
          color: 'brown',
          name: 'dashboard',
          disabled: !_this.isTableauActive
        }, {
          caption: 'PBI Dataset',
          state: _this.$route.query.dataset === 'true' || false,
          color: 'bids',
          name: 'dataset',
          disabled: !_this.isPowerBIActive
        }, {
          caption: 'PBI Report',
          state: _this.$route.query.report === 'true' || false,
          color: 'birp',
          name: 'report',
          disabled: !_this.isPowerBIActive
        }, {
          caption: 'GDS Report',
          state: _this.$route.query.report_gds === 'true' || false,
          color: 'gdsr',
          name: 'report_gds',
          disabled: !_this.isDataStudioActive
        }, {
          caption: 'All',
          state: _this.$route.query.all === 'true' || false,
          color: 'primary',
          name: 'all',
          disabled: false
        }];
        if (_this.buttons.filter(function (x) {
          return x.state == true;
        }).length == 0) {
          _this.buttons[0].state = true;
        }
        _this.$store.dispatch('data-platform/setMainQueryBy', _this.buttons.filter(function (x) {
          return x.state == true;
        })[0].name);
        console.log(_this.mainQueryBy);
      });
    },
    onSearchFilter: function onSearchFilter(filter) {
      console.log(filter);
      this.$parent.show_more_filter = false;
      this.search_with_filter = true;
      this.$store.dispatch("data-platform/setMainQueryAdvance", filter);
      this.$router.push({
        name: 'ContObjectSearch',
        params: {
          q: "any",
          domain: this.pick_domain
        },
        query: {
          all: false,
          table: true,
          term: false,
          data: false,
          book: false
        }
      });
      return true;
    },
    applySearchMini: function applySearchMini() {
      this.sendToSearch();
    },
    closeSearchFilter: function closeSearchFilter() {
      this.$parent.show_more_filter = false;
      this.search_with_filter = false;
      this.$store.dispatch("data-platform/setMainQueryAdvance", "");
    },
    openSearchFilter: function openSearchFilter() {
      this.$parent.show_more_filter = !this.$parent.show_more_filter;
    },
    signout: function signout() {
      var self = this;
      // logout and reload
      tasks.logoutApplication(function () {
        self.$router.push({
          'name': 'ContLogin'
        });
      });
    },
    onClickDropdown: function onClickDropdown() {
      this.$parent.isUserMenu = !this.$parent.isUserMenu;
      this.$parent.isSearchMini = false;
    }
  }
};